import React, { PureComponent, MouseEvent } from 'react';

import { NewFileNamer } from '../renamer';
import { Indent } from '../file-tree-nodes/indent';
import Tooltip from 'rc-tooltip';
import { ActionBox, Action } from '../file-tree-nodes/action-box';
import { Icon } from '../../../atoms/icon';

import styles from './title.module.scss';

type TitleProps = {
	className?: string;
	validateRename: (nextName: string, prevName?: string) => boolean;

	onRefresh?: () => void;
	onFileAdded: (fileId: string) => void;
	onFolderAdded: (fileId: string) => void;
};
export class Title extends PureComponent<TitleProps> {
	state = { isAdding: undefined };

	// static contextType = LayoutContext;

	handleAddFile = (e: { stopPropagation: () => void; }) => {
		e.stopPropagation();
		this.setState({ isAdding: 'file' });
	};

	handleAddFolder = (e: { stopPropagation: () => void; }) => {
		e.stopPropagation();
		this.setState({ isAdding: 'folder' });
	};

	handleSubmitNew = (newFilename: string) => {
		const addType = this.state.isAdding;
		this.setState({ isAdding: undefined });
		if (!newFilename) return;

		const { onFileAdded, onFolderAdded } = this.props;

		if (addType == 'file') {
			return onFileAdded(newFilename);
		}
		if (addType == 'folder') {
			return onFolderAdded(newFilename);
		}
	};

	handleAbortNewFile = () => {
		this.setState({ isAdding: undefined });
	};

	render() {
		const { validateRename, className, children } = this.props;
		const { isAdding } = this.state;

		// const layoutContext = this.context;
		// const { toggleSidebar } = layoutContext;

		return (
			<>
				<div className={styles.title}>
					<div className="stretcher">{children}</div>
					<ActionBox>
						{this.props.onRefresh && (
							<Tooltip overlay="refresh" placement="bottom" mouseLeaveDelay={0}>
								<Action onClick={this.props.onRefresh}>♺</Action>
							</Tooltip>
						)}{' '}
						<Tooltip overlay="new file" placement="bottom" mouseLeaveDelay={0}>
							<Action onClick={this.handleAddFile}>
								<Icon of="new-file" />
							</Action>
						</Tooltip>{' '}
						<Tooltip overlay="new folder" placement="bottom" mouseLeaveDelay={0}>
							<Action onClick={this.handleAddFolder}>
								<Icon of="new-folder" />
							</Action>
						</Tooltip>{' '}
						{/* <Tooltip
							overlay="hide navigator"
							placement="bottom"
							mouseLeaveDelay={0}
						>
							<Action onClick={toggleSidebar}>
								<Icon of="slide-left" />
							</Action>
						</Tooltip> */}
					</ActionBox>
				</div>
				{isAdding === 'file' && (
					<Indent depth={0}>
						<NewFileNamer
							onSubmit={this.handleSubmitNew}
							onAbort={this.handleAbortNewFile}
							validate={validateRename}
						/>
					</Indent>
				)}
				{isAdding === 'folder' && (
					<Indent depth={0}>
						<NewFileNamer
							onSubmit={this.handleSubmitNew}
							onAbort={this.handleAbortNewFile}
							validate={validateRename}
						/>
					</Indent>
				)}
			</>
		);
	}
}
